/* eslint-disable import/namespace */
import React, { useEffect, useState } from "react";
import { useAlert } from "../../../../../context/AlertContext";

import SalaryHomePage from "../../../../../entities/DashboardPage/HRModule/SalaryManagementPage/Home";
import AuthService from "../../../../../api/AuthService";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
  
const SalaryHome = () => {
  const [data, setData] = useState([]); 
  const [taxyearData, setTaxyearData] = useState([]); 
  const [taxyear, setTaxyear] = useState([]);
  const [taxyearList, setTaxyearList] = useState([]); 
  const [loading, setLoading] = useState();

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [open, setOpen] = useState(false);
  const [subscriptionSummary, setSubscriptionSummary] = useState(null);
  const [periodPayslipCount, setPeriodPayslipCount] = useState(null);
  const [isPayslipAccessDisabled, setIsPayslipAccessDisabled] = useState(false);

  const { showAlert } = useAlert();

  const permissionObj = localStorage.getItem("permission");
  const permission = JSON.parse(permissionObj);
  const role = localStorage.getItem("role");
  const employeeId = localStorage.getItem("employeeId");
  const isEmployeeRole = role === "Employee" || role === "employee";
  useEffect(() => {
    getEmployeeList("", page, "");
    getPayslipTaxyear();
    if (isEmployeeRole) {
      // Employees see their own period-based payslip count, not the
      // company-wide subscription payslip limit shown to Admin/SuperAdmin.
      checkPayslipAccess();
    } else {
      fetchSubscriptionSummary();
    }
  },[page])

  // Employee-only, UX affordance only (not a security control - see
  // CLAUDE.md §21). Hides payslip actions once the employee has been
  // deactivated, or - for contractor-type employees - once their contract
  // end date has passed. Real enforcement, if any, happens server-side.
  const checkPayslipAccess = async () => {
    try {
      const result = await AuthService.getProfileView();
      const profile = result?.data;
      if (!profile) return;
      const isRemoved = profile?.isActive === false;
      const empType = profile?.additionalInformation?.empType;
      const contractEnd = profile?.additionalInformation?.contractor?.end;
      const isContractExpired =
        empType === "contractor" && !!contractEnd && new Date(contractEnd).getTime() < Date.now();
      setIsPayslipAccessDisabled(isRemoved || isContractExpired);
    } catch (error) {
      // Cannot determine status - fail open (UX only, see note above).
    }
  };
  const getEmployeeList = async(text, page,sort) =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getEmployeeList(text,page,sort);
      if (result?.success) { 
        setData(result?.data?.employees);
        setTotal(result?.data?.totalCount);
        LoaderHelper.loaderStatus(false);        
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getPayslipTaxyear = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayslipTaxyear();
      if (result?.success) {
        setTaxyearData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const getTaxyear = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getTaxyear(id);
      if (result?.success) {
        setTaxyear(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };
  const getPayslipTaxyearList = async (id) => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayslipTaxyearList(id);
      if (result?.success) {
        setTaxyearList(result?.data?.monthlyData);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  const handleSearch = (text) => {
    text && 
            getEmployeeList(text);
  }
  const handleSort = (sort) => {
    sort && 
            getEmployeeList("","",sort);
  }
  const handleTaxyear = async (date) => {
    setLoading(true);
    try {
      const result = await AuthService.handleTaxyear(date);
      if (result?.success) {
        showAlert(result?.message, "success")
        setLoading(false);
      } else {
        showAlert(result?.message, "success")
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  
  const fetchSubscriptionSummary = async () => {
    try {
      const result = await AuthService.getSalaryStats();
      const summaryPayload = result?.data || result || null;
      setSubscriptionSummary(summaryPayload);
    } catch (error) {
      showAlert(
        error?.message || "Unable to fetch salary stats.",
        "error"
      );
    }
  };

  // Employee-only: count of this employee's own payslips within a given
  // period (financial year or a custom range). Mirrors the employee-scoping
  // already used in usecases/Dashboard/HRModule/Salary/View/index.js so the
  // same permission semantics apply (edit permission sees the company-wide
  // total, view-only sees only their own records).
  const fetchPeriodPayslipCount = async (start, end) => {
    if (!isEmployeeRole || !employeeId) return;
    try {
      const result = await AuthService.getSalaryList("", "", 1, start, end);
      if (result?.success) {
        const hasEditPermission = permission?.salary?.isEdit === true;
        if (hasEditPermission) {
          setPeriodPayslipCount(result?.data?.total ?? 0);
        } else {
          const salaries = (result?.data?.salaries || []).filter(
            (sal) =>
              sal?.employee === employeeId ||
              sal?.employee?._id === employeeId ||
              sal?.employee?.userId === employeeId
          );
          setPeriodPayslipCount(salaries.length);
        }
      }
    } catch (error) {
      // Leave periodPayslipCount as-is; the UI falls back to showing 0.
    }
  };

  return (
    <SalaryHomePage data={data} getEmployeeList={getEmployeeList} role={role}permission={permission} handleSort={handleSort} page={page} total={total} setPage={setPage} handleSearch={handleSearch}
      setData={setData} open={open}setOpen={setOpen} taxyearData={taxyearData} loading={loading} handleTaxyear={handleTaxyear} getPayslipTaxyearList={getPayslipTaxyearList} taxyearList={taxyearList}
      taxyeardate={taxyear} getTaxyear={getTaxyear} subscriptionSummary={subscriptionSummary}
      periodPayslipCount={periodPayslipCount} fetchPeriodPayslipCount={fetchPeriodPayslipCount}
      isPayslipAccessDisabled={isPayslipAccessDisabled}/>
  )

}

export default SalaryHome;
